import React from 'react';
import Modal from 'react-modal';

export default (props) => (
	<div>
		<Modal
			className="Modal errorModal"
			isOpen={props.error}
			onAfterOpen={this.afterOpenModal}
			onRequestClose={this.closeModal}
			overlayClassName="Overlay"
			contentLabel="Example Modal"
		>
			<h2>There was a problem with your submission.</h2>
			<h3>Error(s):</h3>
			<p>{props.errMsg}</p>
			<button onClick={props.onClose}>OK</button>
		</Modal>
	</div>
);



// WEBPACK FOOTER //
// ./src/Components/errorModal.js